const Color = {
  primary: '#0086FF',
  neutral: '#121212',
  neutral90: '#515151',
  neutral80: '#9B9B9B',
  neutral60: '#CDCDCD',
  neutral20: '#F7F7F7',
  white: '#FFFFFF',
  success: '#00D604',
  error: '#FF253A',
  alert: '#FF8A00',
};

export default Color;
